import { createContext, useContext, useEffect, useState } from "react";
import { supabase, setRememberPreference } from "../lib/supabase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchProfile(session.user.id);
      else setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchProfile(session.user.id);
      else {
        setProfile(null);
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  async function fetchProfile(userId) {
    const { data } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", userId)
      .single();

    setProfile(data);
    setLoading(false);
  }

  /**
   * Logowanie hasłem.
   * @param {boolean} rememberMe true = sesja w localStorage (persistent),
   * false = sesja w sessionStorage (do zamknięcia karty)
   */
  async function signIn(email, password, rememberMe = true) {
    setRememberPreference(rememberMe);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) throw error;
  }

  /**
   * Logowanie magic linkiem.
   * Preferencja jest zapisywana teraz; sesja zostanie zapisana w odpowiednim
   * storage gdy użytkownik kliknie link (przez authStorage.setItem).
   */
  async function signInWithMagicLink(email, rememberMe = true) {
    setRememberPreference(rememberMe);

    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: "https://srv110813.seohost.com.pl/skarbnik",
        shouldCreateUser: false, // tylko istniejący użytkownicy
      },
    });

    if (error) throw error;
  }

  async function changePassword(newPassword) {
    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    });

    if (error) throw error;
  }

  async function signOut() {
    await supabase.auth.signOut();
    // authStorage.removeItem czyści oba storages automatycznie
  }

  const isAdmin = profile?.role === "admin";

  return (
    <AuthContext.Provider
      value={{
        user,
        profile,
        loading,
        signIn,
        signInWithMagicLink,
        changePassword,
        signOut,
        isAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}